export const state = () => ({
  profile: {},

  isLoading: true
})

export const mutations = {

  // Запись аккаунта профиля My Acuvue
  setProfile ( state, profile ) {
    state.profile = profile;
  },

  // Запись аккаунта профиля My Acuvue
  setLoading ( state, loading ) {
    state.isLoading = loading;
  }

}



const jsonResponse = {
  pickup_timestamp: "timestamp", // Дата самовывоза
  delivery_timestamp: "timestamp", // Дата доставки курьером

  shop_ids: [], // ID магазинов где товар есть в наличии


};
